export default "__VITE_ASSET__8c0de93b__"